// Simple full-screen loading indicator. Builds its own DOM (same pattern
// as the trivia/HUD overlays in gameScreen.js) so no HTML changes are
// needed - just import { loadingOverlay } and call .show()/.hide().
// Same sky blue as the game's background (see scene.background in
// gameScreen.js) so the transition into gameplay doesn't flash a
// different colour first - and just a spinner, no text.

const overlay = document.createElement("div");
overlay.id = "loading-overlay";
Object.assign(overlay.style, {
  position: "fixed",
  inset: "0",
  display: "none",
  alignItems: "center",
  justifyContent: "center",
  background: "#8fc7f0",
  zIndex: "50",
});

const styleTag = document.createElement("style");
styleTag.textContent = `
  @keyframes loading-overlay-spin { to { transform: rotate(360deg); } }
`;
document.head.appendChild(styleTag);

const spinner = document.createElement("div");
Object.assign(spinner.style, {
  width: "44px",
  height: "44px",
  borderRadius: "50%",
  border: "4px solid rgba(255, 255, 255, 0.5)",
  borderTopColor: "#ffc857",
  animation: "loading-overlay-spin 0.8s linear infinite",
});

overlay.appendChild(spinner);
document.body.appendChild(overlay);

export const loadingOverlay = {
  show() {
    overlay.style.display = "flex";
  },
  hide() {
    overlay.style.display = "none";
  },
};
